var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("el-card", { staticClass: "employees-card-bottom" }, [
        _c(
          "div",
          [
            _c("formBox", {
              ref: "formBox",
              attrs: { notEmployees: _vm.notEmployees, total: _vm.total },
              on: {
                opendrawer: function ($event) {
                  return _vm.$emit("openDrawer", "addDrawerIsShow", "add")
                },
                confirmData: _vm.confirmData,
                handleDelete: _vm.handleDelete,
              },
            }),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.pageLoading,
                    expression: "pageLoading",
                  },
                ],
              },
              [
                _c("Table", {
                  ref: "table",
                  attrs: {
                    tableData: _vm.tableData,
                    total: _vm.total,
                    notEmployees: _vm.notEmployees,
                  },
                  on: {
                    limitFn: _vm.limitFn,
                    pageFn: _vm.pageFn,
                    multipleSelection: _vm.multipleSelection,
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "options",
                      fn: function (ref) {
                        var data = ref.data
                        return [
                          _c(
                            "el-button",
                            {
                              directives: [
                                {
                                  name: "hasPermi",
                                  rawName: "v-hasPermi",
                                  value: ["hr:archives:check"],
                                  expression: "['hr:archives:check']",
                                },
                              ],
                              attrs: { type: "text" },
                              on: {
                                click: function ($event) {
                                  return _vm.hanldeOptions(data, "edit")
                                },
                              },
                            },
                            [_vm._v("查看")]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              attrs: { type: "text" },
                              on: {
                                click: function ($event) {
                                  return _vm.hanldeOptions(data, "delete")
                                },
                              },
                            },
                            [_vm._v("删除")]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              attrs: { type: "text" },
                              on: {
                                click: function ($event) {
                                  return _vm.hanldeOptions(data, "entry")
                                },
                              },
                            },
                            [_vm._v("入职")]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }